import { hideElement, setElementHtml, showElement } from '../../../helpers/generic-js/dom.js'
import { applyRestrictions } from '../../../modules/user/html-parser.js'

import htmlTemplateIndex from './index.html'

export async function showPageUserProfile (params) {
  console.log('showPageUserProfile()')
  const { containerElementId, browserAppUser } = params

  // Prepare the html
  const appUserData = browserAppUser.data
  let htmlIndex = htmlTemplateIndex
  htmlIndex = applyRestrictions(htmlIndex, { userData: appUserData.appUser })

  // Inject in the page
  setElementHtml(containerElementId, htmlIndex)

  // Set page title
  document.title = ['Your user info'].join(' ')

  // Additional
  showUserProfileDetails(appUserData.appUser)
}

function showUserProfileDetails (appUser) {
  console.log(appUser)

  hideElement('userInfo')

  if (!appUser) return

  showElement('userInfo')

  const userInfoString = []

  Object.keys(appUser).forEach(function (oneUserKey) {
    if (!appUser[oneUserKey]) return

    if (typeof appUser[oneUserKey] === 'string') {
      userInfoString.push('<b>' + oneUserKey + ':</b> ' + appUser[oneUserKey])
    } else {
      userInfoString.push('<b>' + oneUserKey + ':</b>')
      const subObj = appUser[oneUserKey]
      Object.keys(subObj)?.forEach(function (oneSubKey) {
        userInfoString.push(' .<b>' + oneSubKey + ':</b> ' + JSON.stringify(subObj[oneSubKey]))
      })
    }
  })

  setElementHtml('userInfo', userInfoString.join('<br>'))
}
